const projects = [
  {
    id: 1,
    title: "F.S. Tesis Yönetimi",
    href: "https://www.fstesisyonetimi.com/",
    ico: "far fa-window-restore",
    content: "F.S. website I developed for a facility management company",
  },
  {
    id: 2,
    title: "Twitter Clone",
    href: "https://github.com/CihatKOCAK/twitterClone",
    ico: "fab fa-github",
    content: "Twitter clone I made with Tailwindcss and Firebase Firestore Database",
  },
  {
    id: 3,
    title: "Portfolio Website",
    href: "https://github.com/CihatKOCAK/React-Portfolio-Website",
    ico: "fab fa-github",
    content: "I designed a portfolio site using react, csss and mui",
  },
  {
    id: 4,
    title: "Shopping Card",
    href: "https://github.com/CihatKOCAK/shopping-cart",
    ico: "fab fa-github",
    content: "I designed an e-commerce site using dashboard.chack.io, stripe and mui",
  },
  {
    id: 5,
    title: "News App",
    href: "https://github.com/CihatKOCAK/mobile-news-app",
    ico: "fab fa-github",
    content: "I have designed a news website with a beautiful and responsive design that brings the news of the country and category you have chosen. I used newsapi as API.",
  },
  {
    id: 6,
    title: "Netflix Clone",
    href: "https://github.com/CihatKOCAK/netflix-Clone",
    ico: "fab fa-github",
    content: "I designed netflix clone application, I used TMDB as api",
  },
  {
    id: 7,
    title: "E-commerce theme",
    href: "https://github.com/CihatKOCAK/simple-e-commerce-theme",
    ico: "fab fa-github",
    content: "I designed an e-commerce site using html, css and js",
  },
];
export { projects };
